import {Stack, Typography} from "@mui/material";
import {appStyles} from "../../../../AppStyles.ts";
import FeatureAccessMessage from "../../../../widgets/FeatureAccessMessage.tsx";

function UXIntelFactorsPanel() {
    return (
        <Stack sx={appStyles.defaultPanelContainer} direction="column" padding={1} width="100%">
            <Stack direction="row" padding={1} justifyContent="center">
                <Typography sx={appStyles.panelSectionTitle}>Factors</Typography>
            </Stack>
            <FeatureAccessMessage />
        </Stack>
    );
}

export default UXIntelFactorsPanel;
